"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RATING_TYPE = exports.ACTIVITY_TYPE = exports.ACTIVITY_SCOPE = exports.REPORT_PREREQUISITE = exports.OPERATION_OPERATOR = exports.CONDITION_VOID_OPERAND = exports.CONDITION_OPERATOR = void 0;
const lists_1 = require("./lists");
var CONDITION_OPERATOR;
(function (CONDITION_OPERATOR) {
    CONDITION_OPERATOR["EQUAL"] = "EQUAL";
    CONDITION_OPERATOR["DIFFERENT"] = "DIFFERENT";
    CONDITION_OPERATOR["GREATER_THAN"] = "GREATER_THAN";
    CONDITION_OPERATOR["LESS_THAN"] = "LESS_THAN";
    CONDITION_OPERATOR["LESS_OR_EQUAL_TO"] = "LESS_OR_EQUAL_TO";
    CONDITION_OPERATOR["GREATER_OR_EQUAL_TO"] = "GREATER_OR_EQUAL_TO";
    CONDITION_OPERATOR["OR"] = "OR";
    CONDITION_OPERATOR["AND"] = "AND";
    CONDITION_OPERATOR["CONTAINS"] = "CONTAINS";
    CONDITION_OPERATOR["IS_NOT_EMPTY"] = "IS_NOT_EMPTY";
    CONDITION_OPERATOR["IS_EMPTY"] = "IS_EMPTY";
})(CONDITION_OPERATOR || (exports.CONDITION_OPERATOR = CONDITION_OPERATOR = {}));
var CONDITION_VOID_OPERAND;
(function (CONDITION_VOID_OPERAND) {
    CONDITION_VOID_OPERAND["NULL"] = "NULL";
    CONDITION_VOID_OPERAND["EMPTY"] = "EMPTY";
})(CONDITION_VOID_OPERAND || (exports.CONDITION_VOID_OPERAND = CONDITION_VOID_OPERAND = {}));
var OPERATION_OPERATOR;
(function (OPERATION_OPERATOR) {
    OPERATION_OPERATOR["ADD"] = "ADD";
    OPERATION_OPERATOR["SUBTRACT"] = "SUBTRACT";
    OPERATION_OPERATOR["MULTIPLY"] = "MULTIPLY";
    OPERATION_OPERATOR["DIVIDE"] = "DIVIDE";
    OPERATION_OPERATOR["EQUAL"] = "EQUAL";
})(OPERATION_OPERATOR || (exports.OPERATION_OPERATOR = OPERATION_OPERATOR = {}));
var REPORT_PREREQUISITE;
(function (REPORT_PREREQUISITE) {
    REPORT_PREREQUISITE["NEED_ONLY_CUSTOMER"] = "NEED_ONLY_CUSTOMER";
    REPORT_PREREQUISITE["NEED_VISIT_AND_GEO_CHECKIN"] = "NEED_VISIT_AND_GEO_CHECKIN";
    REPORT_PREREQUISITE["NO_NEED"] = "NO_NEED";
})(REPORT_PREREQUISITE || (exports.REPORT_PREREQUISITE = REPORT_PREREQUISITE = {}));
exports.ACTIVITY_SCOPE = lists_1.LIST_SCOPE;
var ACTIVITY_TYPE;
(function (ACTIVITY_TYPE) {
    ACTIVITY_TYPE["DEFAULT"] = "DEFAULT";
    ACTIVITY_TYPE["REVIEW"] = "REVIEW";
})(ACTIVITY_TYPE || (exports.ACTIVITY_TYPE = ACTIVITY_TYPE = {}));
var RATING_TYPE;
(function (RATING_TYPE) {
    RATING_TYPE["STAR"] = "STAR";
    RATING_TYPE["GENERIC"] = "GENERIC";
})(RATING_TYPE || (exports.RATING_TYPE = RATING_TYPE = {}));
